import { Snackbar, Alert } from "@mui/material";
import { useContext } from "react";
// import UserContext from "./UserContext";
import { Global_CTX } from "../contexts/global-ctx";

const UniversalFloatingFeedback = () => {
    const { feedback, set_feedback } = useContext(Global_CTX);

    return (
        <Snackbar
            open={feedback!.show}
            onClose={() => set_feedback((f) => ({ ...f, show: false }))}
            message={feedback.message.body}
            title={feedback.message.title}
            autoHideDuration={6 * 1000}
        >
            <Alert severity={feedback?.severity}>
                {feedback.message.title}
            </Alert>
        </Snackbar>
    );
};

export default UniversalFloatingFeedback;
